import type { PropsWithChildren } from 'react'
import React, { createContext, useContext } from 'react'

import type { DeptOption, RoleOption, UserOption } from '../types'

// 数据源provider
export type DataSourceContextType = {
    personOptions?: UserOption[]
    roleOptions?: RoleOption[]
    departmentOptions?: DeptOption[]
    visibleJoinConfigure: boolean
    onVisibleJoinConfigureChange?: (visible: boolean) => void
    /** 数据源列表滚动目标（用于进入数据源页后定位到具体表） */
    scrollToDataSourceId?: string
    /** 消费滚动目标（滚动一次后清空，避免重复滚动） */
    setScrollToDataSourceId?: (id?: string) => void
}

export const DataSourceContext = createContext<DataSourceContextType>({
    visibleJoinConfigure: false
})

type DataSourceProviderProps = PropsWithChildren<{
    value: DataSourceContextType
}>

export const DataSourceProvider: React.FC<DataSourceProviderProps> = props => <DataSourceContext.Provider {...props} />

export const useDataSourceContext = () => useContext(DataSourceContext)
